import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_DOWNLOAD_IN_TUNE_ASSESSMENTS')